'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LOCALE_COOKIE, SEGMENT_ROUTE } from '@config/appConfig';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import * as React from 'react';
import { useRouteCtx } from '../contexts/RouteContextProvider';

/**
 * Next.js router typed to use the Waiter app screenRoutes
 */
export var useWaiterRouter = function useWaiterRouter() {
  var router = useRouter();

  var _useRouteCtx = useRouteCtx(),
      baseRoute = _useRouteCtx.baseRoute,
      screenRoute = _useRouteCtx.screenRoute,
      resolvedPageUrl = _useRouteCtx.resolvedPageUrl;

  var push = React.useCallback(function (screen, options) {
    var params = getUrlParamString(options === null || options === void 0 ? void 0 : options.urlParams);
    var screenUrl = "/".concat(SEGMENT_ROUTE, "/").concat(baseRoute, "/").concat(screen);
    var url = params ? "".concat(screenUrl, "?").concat(params) : screenUrl;
    return router.push(url, options);
  }, [baseRoute, router]);
  var replace = React.useCallback(function (screen, options) {
    var params = getUrlParamString(options === null || options === void 0 ? void 0 : options.urlParams);
    var screenUrl = "/".concat(SEGMENT_ROUTE, "/").concat(baseRoute, "/").concat(screen);
    var url = params ? "".concat(screenUrl, "?").concat(params) : screenUrl;
    return router.replace(url, options);
  }, [baseRoute, router]);
  var changeLocale = React.useCallback(function (locale) {
    Cookies.set(LOCALE_COOKIE, locale);
    router.replace("/".concat(locale, "/").concat(resolvedPageUrl));
  }, [resolvedPageUrl, router]);
  var prefetch = React.useCallback(function (screen) {
    return router.prefetch("/".concat(SEGMENT_ROUTE, "/").concat(baseRoute, "/").concat(screen));
  }, [baseRoute, router]);
  return _objectSpread(_objectSpread({}, router), {}, {
    push: push,
    replace: replace,
    changeLocale: changeLocale,
    prefetch: prefetch,
    screenRoute: screenRoute
  });
}; // create url param string from the param object

var getUrlParamString = function getUrlParamString(params) {
  if (!params) {
    return null;
  }

  var mappedParams = Object.entries(params).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, "=").concat(value);
  });
  return mappedParams.join("&");
};